import React, { useState } from 'react'
import { Input } from 'components/ui'
import { HiOutlineEyeOff, HiOutlineEye } from 'react-icons/hi'

const PasswordInput = (props) => {

	const {onVisibleChange, ...rest} = props

	const [ pwInputType, setPwInputType ] = useState('password')

	const onPasswordVisibleClick = e => {
		e.preventDefault()
		const nextValue = pwInputType === 'password' ? 'text' : 'password'
		setPwInputType(nextValue)
		onVisibleChange?.(nextValue === 'text')
	}

	return (
		<Input
			{...rest}
			type={pwInputType} 
			suffix={
				// A real button: reachable by Tab, named for a screen reader, and 44 px to tap (it was a bare 20 px icon).
				<button
					type="button"
					className="cursor-pointer text-xl flex items-center justify-center"
					style={{ minWidth: 44, minHeight: 44, margin: '0 -10px 0 0' }}
					aria-label={pwInputType === 'password' ? 'Show password' : 'Hide password'}
					aria-pressed={pwInputType !== 'password'}
					onClick={e => onPasswordVisibleClick(e)}
				>
					{ pwInputType === 'password' ? <HiOutlineEyeOff /> : <HiOutlineEye />}
				</button>
			}
		/>
	)
}

export default PasswordInput